import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantConstant } from '@app-constants/tenant.constant';
import { LoginService } from '@app-services/login/login.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { ClassService } from 'src/app/core/services/class.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { clearLocalStorage, navigateBetweenProjects } from 'src/app/helpers/functions';
import { dashboardRoute } from '@app-constants/app.constants';
import { admissionNumberRegex } from '@app-core/components/home/home.component';


@Component({
  selector: 'app-admission-number-login',
  templateUrl: './admission-number-login.component.html',
  styleUrls: ['./admission-number-login.component.css']
})
export class AdmissionNumberLoginComponent implements OnInit {

  tenant : any = TenantConstant.tenant;
  portal: any = TenantConstant.portal;
  loginForm!: FormGroup;
  loginWithAdmissionNumberForm!: FormGroup;
  login: any;
  phoneNumber : any;
  UnauthorizedLoginMessage: any = '';
  show_button: Boolean = false;
  placeHolder: any = 'Phone Number';
  maxLength: any = 10;
  constructor(private dialog: MatDialog, private _formBuilder:FormBuilder,public router: Router,
    public userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any, private loginService: LoginService,
    private testListService: TestlistService,
    private gaService: GAnalyticsService,
    private classService: ClassService,
    private dialogRef: MatDialogRef<AdmissionNumberLoginComponent>) {
      if(this.portal != 'SCORE') {
        this.placeHolder = 'Admission Number';
        this.maxLength = 13;
      }
     }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;


    this.createloginForm();
    if (this.data.admissionNumber) {
      this.setLoginForm();
    }
  }
  createloginForm(): void {
    if(this.portal != 'SCORE') {
      this.loginWithAdmissionNumberForm = this._formBuilder.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(admissionNumberRegex)]],
        password: ['', Validators.required]
      })
    } else {
      this.loginWithAdmissionNumberForm = this._formBuilder.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
        password: ['', Validators.required]
      })
    }
  }
  setLoginForm(): void {
    if(this.portal != 'SCORE') {
      this.loginWithAdmissionNumberForm = this._formBuilder.group({
        admissionNumber: [this.data.admissionNumber, [Validators.required, Validators.pattern(admissionNumberRegex)]],
        password: ['', Validators.required]
      });
    } else {
      this.loginWithAdmissionNumberForm = this._formBuilder.group({
        admissionNumber: [this.data.admissionNumber, [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
        password: ['', Validators.required]
      })
    }
  }

  showPassword(): void {
    this.show_button = !this.show_button;
  }

  get lAdmissionNumber() { return this.loginWithAdmissionNumberForm.controls; }

  loginWithAdmissionNumber() {
    this.loginWithAdmissionNumberForm.markAllAsTouched()
    if (this.loginWithAdmissionNumberForm.valid) {
      console.log(this.loginWithAdmissionNumberForm.value);
      this.loginAdmissionNumber(this.loginWithAdmissionNumberForm.value);
      //this.loginPassword(this.loginForm.value, this.login.countryCode)
    }
  }


  loginAdmissionNumber(body:any) {
    if(this.portal != 'SCORE') {
      this.gaService.sendEvent(
        'pwd_login_attempted', 
        'pwd_login', 
        'pwd_login_attempted', 
        'withAdmissionNumber',
      );  
    }
    clearLocalStorage();
    const newBody = {
      admissionNumber: body.admissionNumber + "",
      password: body.password,
      tenantId: 'srichaitanya'
    }
    this.loginService.loginAdmissionNumberNew(newBody).subscribe((data:any) => {
      // this.toastr.success(data.message);
      console.log(data,'data from server');
      if (data.accessToken) {
        
        if(data.userDto?.grade?.name) {
          data.userDto.grade.name = String(data.userDto.grade.name);
          //data.userDto.grade.name = '9th';
        }
        if(this.portal != 'SCORE') {
          this.gaService.sendEvent(
            'pwd_login_succeeded',
            'pwd_login',
            'pwd_login_succeeded', 
            'withAdmissionNumber',
          );
          if(data.userDto?.grade?.name?.toLowerCase() == '10th') {
            localStorage.setItem('SelectedTab', 'liveclass');
            if(data.userDto?.board?.name.toUpperCase() == "CBSE") {
              data.userDto.exams =
              [{
                "examId": 5,
                "name": "CBSE",
                "description": "Central board examination",
                "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
              }]
            } else {
              data.userDto.exams =
              [{
                "examId": 6,
                "name": "STATE Board",
                "description": "State board examination",
                "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
              }]
            }
          }
          else  {
            let populateNeet = false;
            if(data.userDto?.stream?.name) 
            {
              if(data.userDto.stream.name == "PCMB") {
                data.userDto.exams =
                [{
                  "examId": 1,
                  "name": "JEE Main",
                  "description": "Joint Entrance Examination",
                  "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
                }, {
                  "examId": 2,
                  "name": "NEET",
                  "description": "National Eligibility and Entrance Test",
                  "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
                }, {
                  "examId": 5,
                  "name": "JEE Advanced",
                  "description": "Joint Entrance Examination - Advanced",
                  "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
                }]
              } else if(data.userDto.stream.name == "PCM") {
                data.userDto.exams =
                [{
                  "examId": 1,
                  "name": "JEE Main",
                  "description": "Joint Entrance Examination",
                  "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
                }, {
                  "examId": 5,
                  "name": "JEE Advanced",
                  "description": "Joint Entrance Examination - Advanced",
                  "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
                }]
              } else {
                populateNeet = true;
              }
            } else {
              populateNeet = true;
            }
            
            if(populateNeet) {
              data.userDto.exams =
              [{
                "examId": 2,
                "name": "NEET",
                "description": "National Eligibility and Entrance Test",
                "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
              }]
            }  
          }
        } else {
          let scoreIndex = -1;
          data.userDto?.exams?.some((element, ind) => {
            if(element?.name?.toUpperCase() == 'SCORE') {
              scoreIndex = ind;
              return true;
            }
          });
          if(scoreIndex == -1) {
            data.userDto.exams =
            [{
              "examId": 6,
              "name": "SCORE",
              "description": "National Eligibility and Entrance Test",
              "image": "https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg",
            }]
          } else {
            data.userDto.exams = data?.userDto?.exams[scoreIndex];
          }
        }
        
        localStorage.setItem("targetExamName", data.userDto.selectedExams[0]?.name.replaceAll(" ", "")?.toUpperCase() || data.userDto.exams[0]?.name.replaceAll(" ", "")?.toUpperCase())
        data.userDto.userId = data.userDto?.userId || body.admissionNumber;
        this.dialogRef.close();
        let gradeByName = data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        localStorage.setItem('token', data.accessToken)
        this.userService.setMobileAndName({phone: data.userDto.phone, isdCode: data.userDto.isdCode, firstName: data.userDto.firstName, lastName: data.userDto.lastName, 
          whatsappConsent: data.userDto.whatsappConsent, userId: (data.userDto.userId)? data.userDto.userId : Number(body.admissionNumber) ,profilePhoto:data.userDto.profilePhoto, grade: Number(gradeByName)});
        //console.log(formValue);
        //localStorage.setItem('studentid', data.userDto.phone)
        localStorage.setItem('studentid', body.admissionNumber);
        this.userService.setUserTypes(data.userDto.userType);
        this.userService.updateRequestedUserData(data.userDto);

          this.test(data);
      } else { this.UnauthorizedLoginMessage = 'Incorrect Password! Try again'  }

    },
      (error:any) => {                                     // on error
        // this.toastr.warning(error.error.message)
        console.log(error);
        
        this.UnauthorizedLoginMessage = (error?.error?.message || error?.error?.text);
    });


  }

  test(data: any): any {
    let route = dashboardRoute + (this.portal != 'SCORE' && data?.userDto?.grade?.name?.toLowerCase() == '10th' ?  '/liveclass': '');
    navigateBetweenProjects(this.router, route);
  }
  
  closeDialogue() {
    this.dialogRef.close();
  }
}
